import React, { useEffect } from 'react'
import { PATHS } from 'Config/Routing/paths'
import { withRouter } from 'react-router-dom'
import { getNextLink } from '../../Utils/Link'

const MailingListRouterRaw = props => {
  useEffect(() => {
    const campaignId = props.match.params.campaignId
    const path = `/dashboard/campaigns/${campaignId}${
      PATHS.campaign.mailingList
    }`
    window.location.href = getNextLink(path)
  }, [])

  return null
}

export const MailingListRouter = withRouter(props => {
  return <MailingListRouterRaw {...props} />
})
